var _defs, _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShrivelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402.37 402.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #bc8532;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 201.19,
    cy: 201.19,
    r: 201.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.95,39.71c-91.9,0-166.4,74.5-166.4,166.4s74.5,166.4,166.4,166.4,166.4-74.5,166.4-166.4S292.85,39.71,200.95,39.71ZM200.99,362.9c-86.59,0-156.79-70.2-156.79-156.79S114.4,49.32,200.99,49.32s156.79,70.2,156.79,156.79-70.2,156.79-156.79,156.79Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.78,278.78c24.01,10.08,49.25,11.53,71.64,5.77-11.57-20.02-30.27-37.03-54.28-47.11s-49.25-11.53-71.64-5.77c11.57,20.02,30.27,37.03,54.28,47.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.23,221.26c7.38,1.64,14.66,3.96,21.79,6.95,7.54,3.17,14.71,7.05,21.41,11.53-1.43-13.9-6.18-27.96-14.5-40.85-11.43-17.72-27.64-30.23-45.24-36.62-1.43,18.67,3.3,38.59,14.73,56.31.59.91,1.2,1.8,1.81,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.36,228.22c8.42-3.54,17.04-6.13,25.79-7.78,9.19-16.38,12.95-34.29,11.66-51.18-17.6,6.39-33.81,18.91-45.24,36.62-6.91,10.7-11.35,22.21-13.48,33.76,6.66-4.44,13.78-8.29,21.27-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.23,237.44c-12.51,5.26-23.57,12.41-32.94,20.87,6.06,6.5,11.39,13.61,15.79,21.24l4.28,7.4c10.1-1.31,20.27-3.99,30.23-8.17,24.01-10.08,42.71-27.09,54.28-47.11-22.39-5.76-47.63-4.31-71.64,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.89,247.56c2.68,2.22,5.25,4.55,7.72,6.98.24-18.77,5.99-37.69,16.56-54.06,2.46-3.81,5.16-7.42,8.05-10.85-3.05-22.39-12.49-42.74-26.42-59.17-13.61,16.05-22.93,35.86-26.2,57.64,1.29,1.75,2.54,3.53,3.73,5.37,10.57,16.38,16.32,35.31,16.56,54.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrivelIcon);
export default __webpack_public_path__ + "static/media/Shrivel_icon.a9eb2f6c273abbc39579e9abb4059e8c.svg";
export { ForwardRef as ReactComponent };